import React from "react";
import { Grid2, Stack, Typography } from "@mui/material";
import TextInput from "../../../input/TextInput";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  UseFormRegister,
} from "react-hook-form";
import CollapseSection from "../../../collapse/CollapseSection";
import NumberInput from "../../../input/NumberInput";
import { numeralCustom } from "../../../../../utils/helpers";

interface IInfoSection {
  register: UseFormRegister<FieldValues>;
  control: Control<any>;
  errors: FieldErrors<any>;
}

function InfoSection({ register, control, errors }: IInfoSection) {
  return (
    <CollapseSection title="Thông tin chung" show>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline={false}
              required
              label="Mã KLS/CLS"
              id="ma_khoa"
              name="ma_khoa"
              labelWidth="25%"
              placeholder="Nhập mã khoa lâm sàn, cận lâm sàn"
              register={register}
              errorMessage={errors?.ma_khoa?.message as string}
            />
            <TextInput
              multiline
              label="ID thuốc"
              id="id_thuoc"
              name="id_thuoc"
              labelWidth="25%"
              placeholder="Nhập id thuốc"
              register={register}
            />
            <TextInput
              multiline
              label="Tên mời thầu (hoạt chất)"
              id="hoat_chat"
              name="hoat_chat"
              labelWidth="25%"
              placeholder="Nhập tên mời thầu (hoạt chất)"
              register={register}
            />
            <TextInput
              multiline
              label="Nồng độ, hàm lượng"
              id="ham_luong"
              name="ham_luong"
              labelWidth="25%"
              placeholder="Nhập nồng độ, hàm lượng"
              register={register}
            />
            <TextInput
              multiline
              label="Dạng bào chế"
              id="dang_bao_che"
              name="dang_bao_che"
              labelWidth="25%"
              placeholder="Nhập dạng bào chế"
              register={register}
            />
            <TextInput
              multiline
              label="Đường dùng"
              id="duong_dung"
              name="duong_dung"
              labelWidth="25%"
              placeholder="Nhập đường dùng"
              register={register}
            />
            <TextInput
              multiline
              label="Đơn vị tính"
              id="dvt"
              name="dvt"
              labelWidth="25%"
              placeholder="Nhập Đơn vị tính"
              register={register}
            />
            <TextInput
              multiline
              label="Nhóm"
              id="nhom"
              name="nhom"
              labelWidth="25%"
              placeholder="Nhập nhóm"
              register={register}
            />
            <TextInput
              multiline
              label="Dự toán năm tới"
              id="du_toan"
              name="du_toan"
              labelWidth="25%"
              placeholder="Nhập dự toán năm tới"
              register={register}
            />
            <NumberInput
              label="Số lượng sử dụng 12 tháng liền kề"
              id="sl_sd_trongnam"
              name="sl_sd_trongnam"
              labelWidth="25%"
              placeholder="Nhập số lượng sử dụng 12 tháng liền kề"
              register={register}
            />
            <NumberInput
              label="Đề xuất nhu cầu sử dụng cho năm thứ nhất"
              id="dx_sd_nam0"
              name="dx_sd_nam0"
              labelWidth="25%"
              placeholder="Nhập đề xuất nhu cầu sử dụng cho năm thứ nhất"
              register={register}
            />
            <NumberInput
              readOnly
              label="Tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12 tháng liền kề"
              id="tyle_tt"
              name="tyle_tt"
              labelWidth="25%"
              placeholder="Nhập tỷ lệ tăng trưởng giữa đề xuất năm thứ nhất và số lượng sử dụng 12 tháng liền kề"
              register={register}
              inputProps={{
                endAdornment: <Typography sx={{ px: 2 }}>%</Typography>,
              }}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline
              label="Giải thích lý do vượt 30% số lượng so với 12 tháng liền kề (đề nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)"
              id="dien_giai"
              name="dien_giai"
              labelWidth="25%"
              placeholder="Nhập lý do vượt 30% số lượng so với 12 tháng liền kề (đề nghị ghi cụ thể số ca dự kiến, chi tiết lý do tăng cao)"
              register={register}
            />
            <NumberInput
              label="Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)"
              id="sl_mua_them_nam0"
              name="sl_mua_them_nam0"
              labelWidth="25%"
              placeholder="Nhập Số lượng tùy chọn mua thêm đề xuất năm thứ nhất (tối đa 30%)"
              register={register}
            />
            <NumberInput
              label="Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn định về mặt sử dụng)"
              id="dx_sd_nam1"
              name="dx_sd_nam1"
              labelWidth="25%"
              placeholder="Nhập Đề xuất nhu cầu sử dụng cho năm thứ hai (trường hợp thuốc có sự ổn định về mặt sử dụng)"
              register={register}
            />
            <NumberInput
              label="Số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)"
              id="sl_mua_them_nam1"
              name="sl_mua_them_nam1"
              labelWidth="25%"
              placeholder="Nhập số lượng tùy chọn mua thêm đề xuất năm thứ hai (tối đa 30%)"
              register={register}
            />
            <TextInput
              multiline
              label="Thuốc thuộc danh mục thầu tập trung đã dự trù"
              id="dm_thau_dt"
              name="dm_thau_dt"
              labelWidth="25%"
              placeholder="Nhập thuốc thuộc danh mục thầu tập trung đã dự trù"
              register={register}
            />
            <TextInput
              multiline
              label="Tên thuốc đã sử dụng, dự toán"
              id="ten_thuoc_da_sd"
              name="ten_thuoc_da_sd"
              labelWidth="25%"
              placeholder="Nhập tên thuốc đã sử dụng, dự toán"
              register={register}
            />
            <TextInput
              multiline
              label="Mã nội bộ của thuốc"
              id="ma_noi_bo"
              name="ma_noi_bo"
              labelWidth="25%"
              placeholder="Nhập mã nội bộ của thuốc"
              register={register}
            />
            <Controller
              name="gia_gan_nhat"
              control={control}
              render={({ field: { value, onChange } }) => {
                return (
                  <TextInput
                    multiline={false}
                    label="Giá mua sắm gần nhất tại BVCR"
                    id="gia_gan_nhat"
                    name="gia_gan_nhat"
                    labelWidth="25%"
                    placeholder="Nhập Giá mua sắm gần nhất tại BVCR"
                    value={numeralCustom(value).format()}
                    onChange={(e) => {
                      const val = e.target.value;
                      onChange(numeralCustom(val).value());
                    }}
                  />
                );
              }}
            />
            <TextInput
              multiline
              label="Hệ thuốc"
              id="he_thuoc"
              name="he_thuoc"
              labelWidth="25%"
              placeholder="Nhập hệ thuốc"
              register={register}
            />
            <TextInput
              multiline
              label="Mã ánh xạ bảo hiểm"
              id="ma_anh_xa"
              name="ma_anh_xa"
              labelWidth="25%"
              placeholder="Nhập mã ánh xạ bảo hiểm"
              register={register}
            />
            <TextInput
              multiline
              label="Ghi chú"
              id="note"
              name="note"
              labelWidth="25%"
              placeholder="Nhập ghi chú"
              register={register}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default InfoSection;
